"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSignedUpMessage = void 0;
const workerMessage_1 = require("./workerMessage");
const model_1 = require("../model");
class UserSignedUpMessage extends workerMessage_1.WorkerMessage {
    constructor(user, inviterUser, organization) {
        super(model_1.QueueDefinitions.USER_SIGNED_UP);
        this.user = user;
        this.inviterUser = inviterUser;
        this.organization = organization;
    }
}
exports.UserSignedUpMessage = UserSignedUpMessage;
